import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyNotesComponent',
  setup(__props) {

const { t } = useI18n()

const text = {
  addNotesMesage: t('components.widgets.expedient_reminder_notes.add_notes_message'),
  noNotes: t('components.widgets.expedient_reminder_notes.no_notes')
}

return { __sfc: true,t, text }
}

})